import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';
import { COLORS } from '@lib/ui/theme';

export class SnLocationType extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  @Default('f1ad')
  public icon: string;

  @Expose()
  @Default(COLORS['grey-0'])
  public color: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
